function observeElement(element, callback, rootMargin) {
  if (!('IntersectionObserver' in window)
    || !('IntersectionObserverEntry' in window)
    || !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    callback();
    return;
  }

  const options = {
    rootMargin,
  };

  const intersectionObserverCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && entry.intersectionRatio <= 0) {
        return;
      }

      observer.unobserve(element);
      callback();
    });
  };

  const observer = new IntersectionObserver(intersectionObserverCallback, options);
  observer.observe(element);
}

export default observeElement;
